export default "__VITE_ASSET__Cax6k1AP__"